import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "hooks/use-permission";
import { MeContext } from "contexts/me-context/me-context";

interface RequirePermissionProps {
    permission: string;
    children: React.ReactNode;
}

/**
 * Bloqueia acesso direto por URL a uma tela cuja rota do backend já exige
 * permissão (ex.: navegar pra /ticket digitando na barra, mesmo sem
 * ticket:manage). Sem tela de aviso: quem não tem acesso é redirecionado pro
 * Dashboard em silêncio, igual a se a rota nem existisse. UX only — o
 * enforcement real é sempre o guard do backend.
 */
export const RequirePermission = ({
    permission,
    children,
}: RequirePermissionProps) => {
    const { meLoading } = useContext(MeContext);
    const allowed = usePermission(permission);

    // Sem isso, uma sessão com permissions desatualizado no localStorage (ex.:
    // login antes deste rollout) era redirecionada pro Dashboard antes do
    // /user/me pós-mount trazer o valor certo — mesmo tendo a permissão.
    if (meLoading) {
        return null;
    }

    if (!allowed) {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};
